import React from 'react'

import { servicesArray } from '../Utils/service_util'
import { useNavigate } from 'react-router'
import { Link } from 'react-router-dom'


const two_item_border = (index) => `${index % 2 == 0 ? "border-r-[1px] border-b-[1px]" : " border-b-[1px]"} ${index >= 8 ? " !border-b-0" : " "}`
const three_item_border = (index) => `${index % 3 === 2 ? 'lg:!border-r-0' : 'lg:border-r-[1px]'} ${index >= 6 ? 'lg:!border-b-0' : 'lg:border-b-[1px]'}`




const Services = () => {
    const navigate = useNavigate()
    const handleClick = (event, dataItem) => {
        navigate((`services/${dataItem.href}`))
    }

    return (
        <div className='services-div' id='services-div'>
            <h2 className='text-5xl py-20 uppercase font-bold text-main'><a href='/services'>Services</a></h2>
            <div className='grid grid-cols-2 lg:grid-cols-3 lg:w-3/4 lg:mx-auto text-center'>

                {servicesArray.sort((prev, next) => prev.order - next.order).map((item, index) => {

                    return (<div className={`p-4 group   border-black ${two_item_border(index)} ${three_item_border(index)}  `}>
                        <div className='  bg-opacity-40  mx-auto flex justify-center items-center
                           rounded-full border-black hover:border-main border-2  w-[70%]'>
                            {!item.disabled ? <Link className='h-full w-full p-8 md:p-9 lg:p-14    lg:px-10 xl:px-16' to={`/services/${item.href}`}>  <div className='cursor-pointer h-full w-full' ><img src={item.icon} />
                            </div>
                            </Link> : <div className='h-full w-full p-8 md:p-9 lg:p-14    lg:px-10 xl:px-16'><img src={item.icon} /></div>}
                        </div>

                        {!item.disabled ? <Link to={`/services/${item.href}`}>  <p className='my-2 group-hover:text-main cursor-pointer' >{item.title}</p></Link>
                        : <p className='my-2'>{item.title}</p>}
                    </div>)
                })}
            </div>
            <a className=' my-4 float-right  py-2 bg-main text-[#f2f2f2] px-6 rounded-full' href='/services'>   Learn More</a>
        </div>
    )
}

export default Services